// Module 1: Basic Conversations - Worksheets and Quizzes
export const MODULE1_CONTENT = {
  id: 'module1',
  title: 'Module 1: Basic Conversations',
  description: 'Learn everyday English conversations and greetings',
  worksheets: [
    // Letters Worksheets
    {
      id: 'letters1',
      title: 'Letters Worksheet 1',
      description: 'Learn the English alphabet and letter recognition',
      url: '/worksheets/module1/Semester%201%20-%20Letters%20Worksheet%201%20.pdf',
      filename: 'Semester 1 - Letters Worksheet 1 .pdf',
      order: 1
    },
    {
      id: 'letters2',
      title: 'Letters Worksheet 2',
      description: 'Practice writing and recognizing letters',
      url: '/worksheets/module1/Semester%201%20-%20Letters%20Worksheet%202.pdf',
      filename: 'Semester 1 - Letters Worksheet 2.pdf',
      order: 2
    },
    {
      id: 'letters3',
      title: 'Letters Worksheet 3',
      description: 'Advanced letter practice and exercises',
      url: '/worksheets/module1/Semester%201%20-%20Letters%20Worksheet%203.pdf',
      filename: 'Semester 1 - Letters Worksheet 3.pdf',
      order: 3
    },
    // Greetings Worksheets
    {
      id: 'greetings1',
      title: 'Greetings Worksheet 1',
      description: 'Learn basic greetings like Hello, Good Morning, Good Evening',
      url: '/worksheets/module1/Semester%201%20-%20Greetings%20Worksheet%201.pdf',
      filename: 'Semester 1 - Greetings Worksheet 1.pdf',
      order: 4
    },
    {
      id: 'greetings2',
      title: 'Greetings Worksheet 2',
      description: 'Practice using greetings in different situations',
      url: '/worksheets/module1/Semester%201%20-%20Greetings%20Worksheet%202.pdf',
      filename: 'Semester 1 - Greetings Worksheet 2.pdf',
      order: 5
    },
    {
      id: 'greetings3',
      title: 'Greetings Worksheet 3',
      description: 'Advanced greetings practice and conversation',
      url: '/worksheets/module1/Semester%201%20-%20Greetings%20Worksheet%203.pdf',
      filename: 'Semester 1 - Greetings Worksheet 3.pdf',
      order: 6
    },
    // Introductions Worksheets
    {
      id: 'introductions1',
      title: 'Introductions Worksheet 1',
      description: 'Learn how to introduce yourself - name, age, and basic information',
      url: '/worksheets/module1/Semester%201%20-%20Introductions%20Worksheet%201.pdf',
      filename: 'Semester 1 - Introductions Worksheet 1.pdf',
      order: 7
    },
    {
      id: 'introductions2',
      title: 'Introductions Worksheet 2',
      description: 'Practice introducing yourself in different contexts',
      url: '/worksheets/module1/Semester%201%20-%20Introductions%20Worksheet%202.pdf',
      filename: 'Semester 1 - Introductions Worksheet 2.pdf',
      order: 8
    },
    {
      id: 'introductions3',
      title: 'Introductions Worksheet 3',
      description: 'Learn to introduce others and talk about family',
      url: '/worksheets/module1/Semester%201%20-%20Introductions%20Worksheet%203.pdf',
      filename: 'Semester 1 - Introductions Worksheet 3.pdf',
      order: 9
    },
    {
      id: 'introductions4',
      title: 'Introductions Worksheet 4',
      description: 'Practice asking and answering introduction questions',
      url: '/worksheets/module1/Semester%201%20-%20Introductions%20Worksheet%204.pdf',
      filename: 'Semester 1 - Introductions Worksheet 4.pdf',
      order: 10
    },
    {
      id: 'introductions5',
      title: 'Introductions Worksheet 5',
      description: 'Advanced introduction skills and conversation practice',
      url: '/worksheets/module1/Semester%201%20-%20Introductions%20Worksheet%205.pdf',
      filename: 'Semester 1 - Introductions Worksheet 5.pdf',
      order: 11
    },
    {
      id: 'introductions6',
      title: 'Introductions Worksheet 6',
      description: 'Practice formal and informal introductions',
      url: '/worksheets/module1/Semester%201%20-%20Introductions%20Worksheet%206.pdf',
      filename: 'Semester 1 - Introductions Worksheet 6.pdf',
      order: 12
    },
    {
      id: 'introductions7',
      title: 'Introductions Worksheet 7',
      description: 'Master introduction skills with comprehensive exercises',
      url: '/worksheets/module1/Semester%201%20-%20Introductions%20Worksheet%207.pdf',
      filename: 'Semester 1 - Introductions Worksheet 7.pdf',
      order: 13
    },
    // Asking and Answering Simple Questions Worksheets
    {
      id: 'questions1',
      title: 'Asking and Answering Simple Questions Worksheet 1',
      description: 'Learn to ask and answer basic questions in English',
      url: '/worksheets/module1/Semester%201%20-%20Asking%20and%20Answering%20Simple%20Questions%20Worksheet%201.pdf',
      filename: 'Semester 1 - Asking and Answering Simple Questions Worksheet 1.pdf',
      order: 14
    },
    {
      id: 'questions2',
      title: 'Asking and Answering Simple Questions Worksheet 2',
      description: 'Practice forming questions and giving answers',
      url: '/worksheets/module1/Semester%201%20-%20Asking%20and%20Answering%20Simple%20Questions%20Worksheet%202.pdf',
      filename: 'Semester 1 - Asking and Answering Simple Questions Worksheet 2.pdf',
      order: 15
    },
    {
      id: 'questions3',
      title: 'Asking and Answering Simple Questions Worksheet 3',
      description: 'Advanced question practice and conversation skills',
      url: '/worksheets/module1/Semester%201%20-%20Asking%20and%20Answering%20Simple%20Questions%20Worksheet%203.pdf',
      filename: 'Semester 1 - Asking and Answering Simple Questions Worksheet 3.pdf',
      order: 16
    }
  ],
  quizzes: [
    // Letters Quizzes (after Letters Worksheets)
    {
      id: 'letters-quiz',
      title: 'Letters Quiz',
      description: 'Test your knowledge of English letters and the alphabet',
      order: 3.5,
      googleFormUrl: 'https://forms.gle/reQ62vWvnBMsGsBdA'
    },
    {
      id: 'phonics-quiz',
      title: 'Phonics Quiz',
      description: 'Test your knowledge of letter sounds and phonics',
      order: 3.6,
      googleFormUrl: 'https://forms.gle/9UGQ4dJ9xdNnKmi88'
    },
    // Greetings Quizzes (after Greetings Worksheets)
    {
      id: 'greetings-quiz',
      title: 'Greetings Quiz',
      description: 'Test your knowledge of basic greetings',
      order: 6.5,
      googleFormUrl: 'https://forms.gle/kKP5o1PqHJD19kFe7'
    },
    {
      id: 'polite-phrases-quiz',
      title: 'Polite Phrases Quiz',
      description: 'Test your knowledge of polite phrases like Please, Thank you, and Sorry',
      order: 6.6,
      googleFormUrl: 'https://forms.gle/1PiQ3op66wt82pk99'
    },
    // Introductions Quiz (after Introductions Worksheets)
    {
      id: 'introductions-quiz',
      title: 'Introductions Quiz',
      description: 'Test your knowledge of introducing yourself and others',
      order: 13.5,
      googleFormUrl: 'https://forms.gle/KAroK4PB6cgVqTVs7'
    },
    // Asking and Answering Simple Questions Quiz (after Questions Worksheets)
    {
      id: 'questions-quiz',
      title: 'Asking and Answering Simple Questions Quiz',
      description: 'Test your knowledge of asking and answering simple questions',
      order: 16.5,
      googleFormUrl: 'https://forms.gle/R2489bnfbegY2qt4A'
    },
    // Additional Quizzes
    {
      id: 'vocabulary-quiz',
      title: 'Vocabulary Quiz',
      description: 'Test your knowledge of common vocabulary words',
      order: 17,
      googleFormUrl: 'https://forms.gle/k4xrTdv9HqYnfiJu7'
    },
    {
      id: 'semester1-quiz',
      title: 'Semester 1 Comprehensive Quiz',
      description: 'Complete quiz covering all topics from Semester 1',
      order: 18,
      googleFormUrl: 'https://forms.gle/hqMDRYk6isSg2aVi6'
    }
  ]
};

